import clsx from 'clsx';
import { ComponentPropsWithoutRef } from 'react';
import { fullscreenPage } from './fullscreen-page.css';

/**
 *
 * Use it for pages that should fill whole available area and scroll is not possible
 */

export const FullscreenPage = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return <div className={clsx(fullscreenPage, className)} {...props} />;
};
